"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.editableColumns = exports.tableHeadCells = void 0;
exports.tableHeadCells = [
    { name: "Product" },
    { name: "Last Update", align: "right" },
    { name: "" },
];
exports.editableColumns = ["name"];
